import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; // 実際のエンドポイントに変更する

const config = {
  timeout: 30000,
  method: null,
  url: '',
  data: null,
  withCredentials: true,
};

export default {
  searchTaskCards: (authInfo, tableId, searchWord, filterList, sort) => {
    config.url = baseUrl + '/api/boardView/search';
    config.method = 'POST';
    config.data = { authInfo, tableId, searchWord, filterList, sort };

    return axios.request(config)
      .then((res) => {
        // JSONのデータ部分だけ返す
        if (res.data) {
          return res.data; // data配列を返す
        } else {
          throw new Error(res.data.message || 'エラーが発生しました');
        }
      })
      .catch((err) => {
        let errorMessage = '';
        if (err.code === 'ERR_NETWORK') {
          errorMessage = 'ネットワークエラー: ' + err.message;
        } else if (err.response) {
          errorMessage = err.response.data.msg || 'エラーが発生しました';
          if (err.response.status === 401) {
            router.push('/login');
          }
        } else {
          errorMessage = err.message;
        }
        throw new Error(errorMessage);
      });
  },
};